import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Text,
} from "@chakra-ui/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Meta } from "../../../components/Meta/Meta";
import { useHideNav } from "../../../lib/useHideNav";
import checkIcon from "./images/check.svg";
import gfLogo from "../../../assets/logo.png";

export const ClaimRegistrationComplete = () => {
  useHideNav();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const profileExists = searchParams.get("profileExists") === "true";

  return (
    <Flex direction="column" align="center" bg="white" minH="100vh">
      <Meta>
        <title>You're Ready to Match! | Green Flag</title>
      </Meta>

      {/* Green hero section */}
      <Box w="100%" bg="greenLight.solid">
        <Flex
          direction="column"
          align="center"
          py="2.5rem"
          px="1.5rem"
          maxW="35rem"
          mx="auto"
          textAlign="center"
        >
          <Image
            src={checkIcon}
            alt="Checkmark"
            w="4rem"
            h="4rem"
            mb="1rem"
          />
          <Heading
            as="h1"
            fontFamily="body"
            fontSize="28px"
            fontWeight="700"
            lineHeight="1.3"
            color="white"
            mb="0.75rem"
          >
            You're Ready to Match!
          </Heading>
          {profileExists && (
            <Text
              fontFamily="body"
              fontSize="16px"
              color="white"
              mb="1.5rem"
            >
              You already have a Green Flag profile, so you're good to go!
            </Text>
          )}
          <Button
            mt={profileExists ? undefined : "1.5rem"}
            bg="white"
            color="greenDark.solid"
            size="sm"
            px="2rem"
            textTransform="none"
            borderRadius="full"
            onClick={() => navigate("/profile")}
          >
            Edit Your Profile
          </Button>
        </Flex>
      </Box>

      {/* What happens next section */}
      <Flex
        direction="column"
        align="center"
        py="2.5rem"
        px="1.5rem"
        maxW="35rem"
        mx="auto"
        textAlign="center"
      >
        <Heading
          as="h2"
          fontFamily="body"
          fontSize="24px"
          fontWeight="700"
          lineHeight="1.3"
          color="greenDark.solid"
          mb="1rem"
        >
          What happens next?
        </Heading>
        <Text
          fontFamily="body"
          fontSize="16px"
          color="greenDark.solid"
          lineHeight="1.6"
          mb="0.5rem"
        >
          After the event, you'll be able to log on to{" "}
          <Text as="span" color="greenLight.solid" fontWeight="500">
            greenflagdate.com
          </Text>{" "}
          and match with other people who attended the event!
        </Text>
        <Text
          fontFamily="body"
          fontSize="16px"
          color="greenDark.solid"
          lineHeight="1.6"
        >
          If it's a mutual match, you'll have the chance to connect!
        </Text>
      </Flex>

      {/* Footer: powered by */}
      <Box w="100%" borderTop="1px solid" borderColor="gray.200">
        <Flex
          align="center"
          justify="center"
          gap="0.75rem"
          py="1.5rem"
          px="1.5rem"
        >
          <Text fontSize="14px" fontWeight="500" color="greenDark.solid">
            matching powered by
          </Text>
          <Image src={gfLogo} alt="Green Flag" h="20px" />
        </Flex>
      </Box>
    </Flex>
  );
};
